import {
    OrderStatusType,
    type AdminOrderStatusHistoryItem,
} from "@models/order";
import { StatusTimeline } from "@admin/_components/StatusTimeline";

interface OrderHistoryProps {
    // In the API's order: oldest first.
    history: AdminOrderStatusHistoryItem[];
    // The page's own re-read of the order is in flight, so the history shown
    // may be about to change.
    isRefreshing: boolean;
}

// The order's status names, as the audit trail has always shown them; the
// shared timeline falls back to the raw value for one this build lacks.
const orderStatusLabel = (status: OrderStatusType): string | undefined =>
    OrderStatusType[status];

// The order's status changes (O4), newest first, each with who made it: the
// name the API gives, the system actor's ("System Actor") included, and no
// one when it gives none.
export const OrderHistory = ({ history, isRefreshing }: OrderHistoryProps) => (
    <>
        {isRefreshing && (
            <p role="status" className="mb-3 text-sm text-neutral/70">
                Refreshing history…
            </p>
        )}
        <StatusTimeline
            entries={[...history].reverse().map((entry) => ({
                ...entry,
                note: entry.notes,
                changedBy: entry.changedByUserName,
            }))}
            labelOf={orderStatusLabel}
        />
    </>
);
